var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.349 8.899l-2.246-2.246 1.623-1.624 2.245 2.245-1.622 1.625zm-5.783 5.788l-2.48.226.22-2.463 4.68-4.681 2.247 2.247-4.667 4.671zm8.604-8.572l-.001-.001-2.282-2.282c-.617-.616-1.678-.645-2.263-.057L4.127 11.27c-.272.271-.44.631-.475 1.012l-.316 3.475c-.021.246.066.49.241.664.158.158.37.244.59.244.025 0 .05 0 .075-.003l3.475-.316c.382-.035.74-.202 1.012-.473l7.497-7.498c.607-.608.581-1.623-.056-2.261z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.609ed6e1.svg";
export { ForwardRef as ReactComponent };